import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { setHideAppBanner, shouldShowBanner } from '../../common/cookie';
import { MobileBannerContent } from '../IOSMobileBannerContent';
import { jsx as _jsx } from "react/jsx-runtime";
export var MobileBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileBanner, _React$Component);
  var _super = _createSuper(MobileBanner);
  function MobileBanner() {
    var _this;
    _classCallCheck(this, MobileBanner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false
    });
    _defineProperty(_assertThisInitialized(_this), "closeBanner", function () {
      var caCloseBanner = _this.props.caCloseBanner;
      caCloseBanner();
      _this.setState({
        open: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickLink", function () {
      var caClickOnBanner = _this.props.caClickOnBanner;
      caClickOnBanner();
      _this.setState({
        open: false
      });
    });
    return _this;
  }
  _createClass(MobileBanner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (shouldShowBanner()) {
        var _caShowBanner = this.props.caShowBanner;
        _caShowBanner();
        this.setState({
          open: true
        });
        setHideAppBanner();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var url = this.props.url;
      return open ? /*#__PURE__*/_jsx(MobileBannerContent, {
        url: url,
        onBannerClick: this.handleClickLink,
        closeBanner: this.closeBanner,
        open: open
      }) : null;
    }
  }]);
  return MobileBanner;
}(React.Component);